import "owl.carousel";

if (is_allowed_cookie("_ga")) {
  // Google Analytics
  (function (i, s, o, g, r, a, m) {
    i["GoogleAnalyticsObject"] = r;
    (i[r] =
      i[r] ||
      function () {
        (i[r].q = i[r].q || []).push(arguments);
      }),
      (i[r].l = 1 * new Date());
    (a = s.createElement(o)), (m = s.getElementsByTagName(o)[0]);
    a.async = 1;
    a.src = g;
    m.parentNode.insertBefore(a, m);
  })(
    window,
    document,
    "script",
    "https://www.google-analytics.com/analytics.js",
    "ga"
  );

  ga("create", "UA-98095004-1", "auto");
  ga("send", "pageview");
}

(function ($) {
  $(document).ready(function () {
    $(".cookie-link").on("click", function () {
      $(".gdpr-preferences").trigger("click");
    });

    // Location FAQ accordion – slide toggle; only one open at a time
    $(document).on("click", ".location-faq-question", function () {
      var $btn = $(this);
      var $item = $btn.closest(".location-faq-item");
      var $answer = $item.find(".location-faq-answer");
      var expanded = $btn.attr("aria-expanded") === "true";

      // Close any other open accordion items in this section
      $item.siblings(".location-faq-item.is-open").each(function () {
        var $other = $(this);
        var $otherBtn = $other.find(".location-faq-question");
        var $otherAnswer = $other.find(".location-faq-answer");
        $otherBtn.attr("aria-expanded", "false");
        $other.removeClass("is-open");
        $otherAnswer.slideUp(300, function () {
          $otherAnswer.prop("hidden", true);
        });
      });

      $btn.attr("aria-expanded", !expanded);
      $item.toggleClass("is-open", !expanded);
      if (!expanded) {
        $answer.slideDown(300, function () {
          $answer.prop("hidden", false);
        });
      } else {
        $answer.slideUp(300, function () {
          $answer.prop("hidden", true);
        });
      }
    });

    // Tracking
    // Header
    if (typeof ga === "function") {
      $(".logo-link-header").on("click", function () {
        ga("send", "event", "Button", "Logo Header");
      });

      $("#trigger-overlay").on("click", function () {
        ga("send", "event", "Button", "Menu Button Open");
      });

      $(".menu-overlay-close").on("click", function () {
        ga("send", "event", "Button", "Menu Button Close");
      });

      $(".email-link-header").on("click", function () {
        ga("send", "event", "Button", "Header Email Link");
      });

      // Home
      $(".intro-pod").on("click", function () {
        ga("send", "event", "Button", "Intro Pods", $(this).attr("href"));
      });

      $(".intro-content-btn").on("click", function () {
        ga(
          "send",
          "event",
          "Button",
          "Intro Content Link",
          $(this).text(),
          $(this).attr("href")
        );
      });

      $(".yellow-section-btn").on("click", function () {
        ga(
          "send",
          "event",
          "Button",
          "Yellow Section Link",
          $(this).text(),
          $(this).attr("href")
        );
      });

      // Footer
      $("footer .email-link").on("click", function () {
        ga(
          "send",
          "event",
          "Button",
          "Footer Email Link",
          $(this).text(),
          $(this).attr("href")
        );
      });

      // Internal Pages
      $(".asset-link").on("click", function () {
        ga(
          "send",
          "event",
          "Button",
          "Asset Link",
          $(this).text(),
          $(this).attr("href")
        );
      });

      $(".cta-btn").on("click", function () {
        ga(
          "send",
          "event",
          "Button",
          "Call to Action Link",
          $(this).text(),
          $(this).attr("href")
        );
      });

      $(".custom-layout a").on("click", function () {
        ga(
          "send",
          "event",
          "Button",
          "Custom Layout Link",
          $(this).text(),
          $(this).attr("href")
        );
      });

      // Team
      $(".owl-dots .owl-dot").on("click", function () {
        ga("send", "event", "Button", "Carousel dots");
      });
    }

    // Smooth scroll
    $('a[href^="#"]').on("click", function (e) {
      // No hash or just "#" – let the link work normally (e.g. "View location" button with updated href)
      if (!this.hash || this.hash === "#") return;
      e.preventDefault();

      if (
        location.pathname.replace(/^\//, "") ==
          this.pathname.replace(/^\//, "") ||
        location.hostname == this.hostname
      ) {
        var hashId = this.hash.slice(1);
        var target = $(this.hash);
        target = target.length && hashId
          ? target
          : hashId
            ? $("[name=" + CSS.escape(hashId) + "]")
            : $();
        if (target.length) {
          $("html,body").animate(
            {
              scrollTop: target.offset().top - $("header").outerHeight() - 80,
            },
            1000
          );
          return false;
        }
      }
    });

    // Sticky header
    var windowHeight = $(window)[0].innerHeight,
      windowScrollTop = $(window).scrollTop(),
      scroll;

    var heroFadeFunction = function () {
      $(".hero").each(function () {
        if (windowScrollTop <= windowHeight) {
          var scrollPercent = windowScrollTop / windowHeight,
            scrollOpacity = scrollPercent + scrollPercent * 0.5,
            scrollTransform = scrollPercent * 6 + 2;

          $(".hero")
            .find(".overlay")
            .css({
              transform: "translate(0, -" + scrollTransform + "%)",
            });
        }
      });
    };

    $(window).on("scroll touchmove", function () {
      heroFadeFunction();
    });

    heroFadeFunction();

    // Scroll
    var scroll = $(window).scrollTop();

    setSticky(scroll);

    $(window).on("scroll", function () {
      scroll = $(window).scrollTop();

      setSticky(scroll);
    });

    function setSticky(scroll) {
      if (scroll >= 10) {
        $("header").addClass("is-sticky");
      } else {
        $("header").removeClass("is-sticky");
      }
    }

    // Map – only run when Google Maps API is available (e.g. after cookie consent or when script has loaded)
    var map;

    function initMapWhenReady() {
      if (typeof google === "undefined" || typeof google.maps === "undefined") {
        return false;
      }
      var mapEl = document.getElementById("map");
      if (!mapEl) return false;

      var grantplant = new google.maps.LatLng(51.534427, -0.735637);

      var mapOptions = {
        scrollwheel: false,
        zoom: 14,
        center: grantplant,
        mapId: "map",
      };

      map = new google.maps.Map(mapEl, mapOptions);

      var contentString =
        '<div class="map-content">' +
        "<h2><strong>Grant Plant</strong></h2>" +
        "<p>" +
        '<i class="fa fa-phone"></i> ' +
        phoneNumber +
        "<br />" +
        '<i class="fa fa-envelope-o"></i> <a href="mailto:' +
        emailAddress +
        '">' +
        emailAddress +
        "</a>" +
        "</p>" +
        "</div>";

      var infowindow = new google.maps.InfoWindow({
        content: contentString,
      });

      var markerEl = document.createElement("div");
      markerEl.innerHTML =
        '<img src="' +
        siteUrl +
        '/assets/img/marker.png" alt="Marker" width="34" height="50" class="advanced-marker-img" />';

      var markerView = new google.maps.marker.AdvancedMarkerElement({
        map: map,
        position: grantplant,
        title: "Grant Plant",
        content: markerEl,
        gmpClickable: true,
      });

      function openInfoWindow() {
        infowindow.open({
          anchor: markerView,
          map: map,
        });
      }
      if (markerView.element && typeof markerView.element.addEventListener === "function") {
        markerView.element.addEventListener("gmp-click", openInfoWindow);
      } else {
        markerView.addListener("click", openInfoWindow);
      }

      window.addEventListener("resize", function () {
        if (map && typeof map.getCenter === "function") {
          var center = map.getCenter();
          google.maps.event.trigger(map, "resize");
          map.setCenter(center);
        }
      });

      return true;
    }

    if ($("#map").length > 0) {
      function runMapInit() {
        initMapWhenReady();
      }
      if (window.grantPlantMapsLoaded) {
        runMapInit();
      } else {
        (window.grantPlantMapsQueue = window.grantPlantMapsQueue || []).push(runMapInit);
      }
    }

    // Logo Carousel (footer partner logos + location accreditations; each wrapper has its own prev/next)
    $(".logo-slider-wrapper").each(function () {
      var $wrapper = $(this);
      var $slider = $wrapper.find(".logo-slider");
      if ($slider.length && typeof $.fn.owlCarousel === "function") {
        $slider.owlCarousel({
          loop: true,
          margin: 10,
          dots: false,
          autoplay: true,
          autoplayTimeout: 3000,
          responsive: {
            0: { items: 1 },
            600: { items: 2 },
            1000: { items: 3 },
          },
        });
        $wrapper.find(".prev").on("click", function () {
          $slider.trigger("prev.owl.carousel");
        });
        $wrapper.find(".next").on("click", function () {
          $slider.trigger("next.owl.carousel");
        });
      }
    });

    // Team Carousel
    var teamSlider = $(".team-slider");
    if (teamSlider.length && typeof $.fn.owlCarousel === "function") {
      teamSlider.owlCarousel({
        items: 1,
        loop: true,
        margin: 10,
        dots: false,
      });
      $(".team-slider-wrapper .prev").on("click", function () {
        teamSlider.trigger("prev.owl.carousel");
      });
      $(".team-slider-wrapper .next").on("click", function () {
        teamSlider.trigger("next.owl.carousel");
      });
    }

    // Location Testimonials Carousel – one quote per slide (each wrapper has its own slider and prev/next)
    $(".testimonial-slider-wrapper").each(function () {
      var $wrapper = $(this);
      var $slider = $wrapper.find(".testimonial-slider");
      if ($slider.length && typeof $.fn.owlCarousel === "function") {
        $slider.owlCarousel({
          items: 1,
          loop: true,
          margin: 0,
          dots: false,
          responsive: {
            0: { items: 1 },
            600: { items: 1 },
            1000: { items: 1 },
          },
        });
        $wrapper.find(".prev").on("click", function () {
          $slider.trigger("prev.owl.carousel");
        });
        $wrapper.find(".next").on("click", function () {
          $slider.trigger("next.owl.carousel");
        });
      }
    });

    // Equipment Gallery
    $(".equipment-gallery-wrapper").each(function () {
      // the containers for all your galleries
      $(this)
        .find(".equipment-gallery")
        .magnificPopup({
          delegate: "a", // the selector for gallery item
          type: "image",
          gallery: {
            enabled: true,
          },
        });

      $(this)
        .find(".feature-equipment-img")
        .on("click", function () {
          $(this)
            .parents(".equipment-gallery-wrapper")
            .find(".equipment-gallery")
            .find("a")
            .eq(0)
            .trigger("click");
        });
    });

    // Match Height (only when plugin is loaded – e.g. by a plugin)
    if (typeof $.fn.matchHeight === "function") {
      $(".equipment-rows .row .half").matchHeight();
    }

    // Menu overlay: avoid aria-hidden with focusable descendants (a11y)
    var triggerBtn = $("#trigger-overlay"),
      overlay = $(".menu-overlay"),
      closeBtn = $(".menu-overlay-close"),
      overlayFocusableSelector =
        "a[href], button, input, select, textarea, [tabindex]";

    function setOverlayHidden(hidden) {
      overlay.attr("aria-hidden", hidden ? "true" : "false");
      overlay
        .find(overlayFocusableSelector)
        .each(function () {
          if (hidden) {
            $(this).attr("tabindex", "-1");
          } else {
            $(this).removeAttr("tabindex");
          }
        });
    }

    setOverlayHidden(true);

    triggerBtn.on("click", function () {
      overlay.addClass("open");
      $("body").addClass("menu-active");
      setOverlayHidden(false);
      closeBtn.focus();
    });

    closeBtn.on("click", function () {
      overlay.removeClass("open");
      $("body").removeClass("menu-active");
      setOverlayHidden(true);
      triggerBtn.focus();
    });

    // Select (only when Selectric plugin is loaded – e.g. by a plugin)
    if (typeof $.fn.selectric === "function") {
      $("select").selectric();
      $(document).on("nfFormReady", function (e, layoutView) {
        $("select").selectric();
      });
    }

    // Hide honeypot field (Ninja Forms anti-spam "leave it empty" message)
    function hideHoneypot() {
      $(".nf-form-wrap label, .form-area .nf-field-container label").each(function () {
        var text = ($(this).text() || "").toLowerCase();
        if (text.indexOf("leave") !== -1 && (text.indexOf("empty") !== -1 || text.indexOf("human") !== -1)) {
          $(this).closest(".nf-field-container").addClass("nf-honeypot-wrap").css({
            position: "absolute",
            width: "1px",
            height: "1px",
            margin: "-1px",
            padding: 0,
            overflow: "hidden",
            clip: "rect(0,0,0,0)",
            border: 0
          });
        }
      });
    }
    hideHoneypot();
    $(document).on("nfFormReady", hideHoneypot);

    // Ensure reCAPTCHA API is loaded before form use (fixes "Error trying to execute grecaptcha")
    // Theme enqueues the script in head when possible; this is a fallback if script loads late
    (function ensureRecaptchaReady() {
      var recaptchaEl = document.querySelector(".g-recaptcha, [data-sitekey]");
      if (!recaptchaEl || typeof window.grecaptcha !== "undefined") return;
      var sitekey = recaptchaEl.getAttribute("data-sitekey");
      if (!sitekey) return;

      window.grantPlantRecaptchaOnload = function () {
        window.grantPlantRecaptchaReady = true;
      };
      var script = document.createElement("script");
      script.src =
        "https://www.google.com/recaptcha/api.js?onload=grantPlantRecaptchaOnload&render=explicit";
      script.async = true;
      script.defer = true;
      document.head.appendChild(script);
    })();

    /** Product Filter (only when Isotope plugin is loaded – e.g. by a plugin) */
    if ($(".grid").length && typeof $.fn.isotope === "function") {
      var $grid = $(".grid").isotope({
        itemSelector: ".element-item",
        layoutMode: "fitRowsCentered",
      });

      $("#filters").on("click", "button", function () {
        var filterValue = $(this).attr("data-filter");
        $grid.isotope({
          filter: filterValue,
          layoutMode: "fitRowsCentered",
        });
      });

      $("#weights").on("click", "button", function () {
        var filterValue = $(this).attr("data-filter") + ".cat-kubota-excavators";
        $grid.isotope({
          filter: filterValue,
          layoutMode: "fitRowsCentered",
        });
      });

      $(".button-group, .inline-group").each(function (i, buttonGroup) {
        var $buttonGroup = $(".button-group, .inline-group");
        $buttonGroup.on("click", "button", function () {
          $buttonGroup.find(".is-checked").removeClass("is-checked");
          $(this).addClass("is-checked");
        });
      });

      $(".button-group").each(function (i, buttonGroup) {
        $(this).on("click", "button", function () {
          if ($(this).attr("data-filter") === ".cat-kubota-excavators") {
            $(".inline-group").slideDown();
          } else {
            $(".inline-group").slideUp();
          }
        });
      });

      $(".inline-group").on("click", ".clear-button", function () {
        $(".all-button").addClass("is-checked");
        $(".inline-group").slideUp();
      });
    }

    // Areas we cover: custom dropdown with search; updates excerpt and CTA (data from data-locations)
    $(".grant-plant-areas-cover").each(function () {
      var $block = $(this);
      var id = $block.attr("id");
      if (!id) return;
      var dataRaw = $block.attr("data-locations");
      if (!dataRaw) return;
      var data = [];
      try {
        data = JSON.parse(dataRaw);
      } catch (e) {
        return;
      }
      var byId = {};
      data.forEach(function (item) {
        byId[String(item.id)] = item;
      });
      var $trigger = $("#" + id + "-trigger");
      var $triggerLabel = $trigger.find(".areas-cover-trigger-label");
      var $panel = $("#" + id + "-panel");
      var $search = $("#" + id + "-search");
      var $list = $("#" + id + "-list");
      var $excerpt = $("#" + id + "-excerpt");
      var $button = $("#" + id + "-button");
      var placeholder = $triggerLabel.text();
      if (!$trigger.length || !$panel.length || !$list.length || !$excerpt.length || !$button.length) return;

      function setSelection(selectedId) {
        if (!selectedId || !byId[selectedId]) {
          $excerpt.empty().attr("hidden", "hidden");
          $button.attr("href", "#").parent().attr("hidden", "hidden");
          $triggerLabel.text(placeholder);
          $list.find(".areas-cover-option").removeClass("is-selected");
          return;
        }
        var item = byId[selectedId];
        $excerpt.html("<p>" + (item.excerpt || "").replace(/</g, "&lt;").replace(/>/g, "&gt;") + "</p>").removeAttr("hidden");
        $button.attr("href", item.url).parent().removeAttr("hidden");
        $triggerLabel.text(item.title);
        $list.find(".areas-cover-option").removeClass("is-selected").filter("[data-id=\"" + selectedId + "\"]").addClass("is-selected");
      }

      function openPanel() {
        $panel.removeAttr("hidden");
        $trigger.attr("aria-expanded", "true");
        $search.val("").trigger("input");
        setTimeout(function () {
          $search.focus();
        }, 0);
      }

      function closePanel() {
        $panel.attr("hidden", "hidden");
        $trigger.attr("aria-expanded", "false");
        $search.val("");
        filterList("");
      }

      function filterList(q) {
        var lower = (q || "").toLowerCase().trim();
        $list.find(".areas-cover-option").each(function () {
          var text = $(this).text().toLowerCase();
          var show = !lower || text.indexOf(lower) !== -1;
          $(this).toggle(show);
        });
      }

      $trigger.on("click", function (e) {
        e.stopPropagation();
        if ($panel.attr("hidden") !== undefined) {
          openPanel();
        } else {
          closePanel();
        }
      });

      $search.on("input", function () {
        filterList($(this).val());
      });

      $search.on("click", function (e) {
        e.stopPropagation();
      });

      $list.on("click", ".areas-cover-option", function (e) {
        e.stopPropagation();
        var selectedId = $(this).attr("data-id");
        setSelection(selectedId);
        closePanel();
      });

      $(document).on("click.areasCover" + id, function (e) {
        if ($block.has(e.target).length === 0) {
          closePanel();
        }
      });

      $(document).on("keydown.areasCover" + id, function (e) {
        if (e.key === "Escape" && $panel.attr("hidden") === undefined) {
          closePanel();
          $trigger.focus();
        }
      });

      setSelection(null);
    });
  });
})(jQuery);
